/* Cartridges Online welcome offer pop-up. See snippets/co-welcome-popup.liquid. */
(function () {
  var el = document.getElementById('co-welcome'); if (!el) return;
  var KEY = 'co_welcome', q = new URLSearchParams(location.search), force = q.get('co_welcome'), state = {};
  try { state = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) {}
  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
  var formState = el.querySelector('.co-welcome__form-state'), thanks = el.querySelector('.co-welcome__thanks-state');
  var posted = !!el.querySelector('[data-co-posted]') || q.get('customer_posted') === 'true';
  var errored = !!el.querySelector('[data-co-error]');
  function open(mode) {
    var t = mode === 'thanks'; formState.hidden = t; thanks.hidden = !t; el.hidden = false;
    var f = el.querySelector(t ? '[data-co-copy]' : '#co-welcome-email'); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function close() { el.hidden = true; state.seen = Date.now(); save(); }
  el.querySelector('.co-welcome__close').addEventListener('click', close);
  var no = el.querySelector('[data-co-dismiss]'); if (no) no.addEventListener('click', function () { state.dismissed = Date.now(); close(); });
  el.addEventListener('click', function (e) { if (e.target === el) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });
  var copy = el.querySelector('[data-co-copy]');
  if (copy) copy.addEventListener('click', function () {
    try { navigator.clipboard.writeText('WELCOME10'); } catch (e) {}
    copy.textContent = 'Copied — see you at checkout';
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#co-welcome"]');
    if (a) { e.preventDefault(); open(state.subscribed ? 'thanks' : 'form'); }
  });
  if (force === '0') return;
  if (posted) {
    state.subscribed = Date.now(); save(); open('thanks');
    if (history.replaceState) { q.delete('customer_posted'); history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q : '')); }
    return;
  }
  if (errored) { open('form'); return; }
  if (force === '1') { open('form'); return; }
  if (state.subscribed) return;
  var DAY = 864e5;
  if (state.dismissed && Date.now() - state.dismissed < 30 * DAY) return;
  if (state.seen && Date.now() - state.seen < 7 * DAY) return;
  var shown = false, mobile = matchMedia('(max-width: 749px)').matches;
  function show() { if (shown) return; shown = true; open('form'); }
  setTimeout(show, mobile ? 12000 : 8000);
  if (!mobile) document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) show(); });
  window.addEventListener('scroll', function () {
    if ((window.scrollY + window.innerHeight) / document.documentElement.scrollHeight > 0.5) show();
  }, { passive: true });
})();
